import { render } from "./LoginRightPanel.vue?vue&type=template&id=01bbc795&scoped=true"
import script from "./LoginRightPanel.vue?vue&type=script&lang=js"
export * from "./LoginRightPanel.vue?vue&type=script&lang=js"

import "./LoginRightPanel.vue?vue&type=style&index=0&id=01bbc795&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01bbc795"

export default script